/**
 * PC终端对接类
 */
import userSessionUtils from '@/common/userSessionUtils'
import config from 'config'

const

	/**
	 * @brief 请求登录信息
	 * @return 请求号
	 * @author chenxy
	 * @date 20181207
	 */
	requestLoginSession = () => {
		/**
		 * @brief 请求登录信息
		 * @return 请求号
		 */
		let loginuuid = get_uuid()
		userSessionUtils.setInfoSStorage('loginuuid', loginuuid)
		window.QtSubmit.JSIRequestLoginSession(loginuuid);
	},

	/**
	 * @brief 显示网厅
	 * @return 请求号
	 * @author chenxy
	 * @date 20181207
	 */
	showOnlineBusinessHallView = (url) => {
		/**
		 * @brief 显示网厅
		 * @param url 跳转至的URL
		 * @return 是否成功
		 */
		switch (url) {
			case '1':
				url = config.global.netUrl[0]
				break;
			case '2':
				url = config.global.netUrl[1]
				break;
			case '3':
				url = config.global.netUrl[2]
				break;
			case '4':
				url = config.global.netUrl[3]
				break;
		}
		if (window.qt) {
			window.QtSubmit.JSIShowOnlineBusinessHallView(url)
		} else {
			window.open(url)

		}
	},

	get_uuid = () => {
		var s = [];
		var hexDigits = "0123456789ehtsec";
		for (var i = 0; i < 36; i++) {
			s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
		}
		s[14] = "4";
		s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
		s[8] = s[13] = s[18] = s[23] = "-";

		var uuid = s.join("");
		return uuid
	}
;

const ssoUtils = {
	requestLoginSession: requestLoginSession, // 请求登录信息
	showOnlineBusinessHallView: showOnlineBusinessHallView, // 显示网厅
}

export default ssoUtils;



// WEBPACK FOOTER //
// ./src/utils/ssoUtils.js